<template>
  <div v-if="loader" class="spinner-overlay">
    <div class="spinner-container">
      <DualRingLoader :size="100" :color="loadercolor" />
    </div>
  </div>
</template>

<script>
import { DualRingLoader } from "vue-spinners-css";
export default {
  components: {
    DualRingLoader,
  },
  props: ["loader"],
  data() {
    return {
      loadercolor: "#1BA3BA",
    };
  },
};
</script>

<style scoped>
.spinner-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
